import responseMapper from '../responseMaps/responseMapper';
import { SXMResponse } from '../responseMaps/SXMResponse';
import { HTTP_METHOD } from './json';

export default async function submit(action: string, method: HTTP_METHOD, formData: FormData) {
    const queryArray = [];
    const entriesIterator = formData.entries();
    let entry = entriesIterator.next();

    while (!entry.done) {
        const key = entry.value[0];
        const value = entry.value[1] as string;
        queryArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        entry = entriesIterator.next();
    }

    const queryString = queryArray.join('&');

    const response = await fetch(action, {
        method: method,
        body: queryString,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });

    return response;
}

export async function submitUrlencoded(action: string, method: HTTP_METHOD, formData: FormData) : Promise<SXMResponse> {
    const queryArray = [];
    const entriesIterator = formData.entries();
    let entry = entriesIterator.next();

    while (!entry.done) {
        const key = entry.value[0];
        const value = entry.value[1] as string;
        queryArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        entry = entriesIterator.next();
    }

    const queryString = queryArray.join('&');

    const response = await fetch(action, {
        method: method,
        body: queryString,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });

    return responseMapper(action, response);
}
